const STORAGE_KEY = "gondola.whatsapp-link.v1";
const MAX_AGE_MS = 10 * 60_000;

// This synchronous head script runs before analytics and hydration. A fragment
// never reaches the server, and the continuation never enters an auth URL.
export const WHATSAPP_LINK_BOOTSTRAP = `(function(){if(location.pathname!=="/whatsapp/link")return;var hash=location.hash;var query=location.search;history.replaceState(null,"","/whatsapp/link");try{if(hash||query){sessionStorage.removeItem("${STORAGE_KEY}");var token=new URLSearchParams(hash.slice(1)).get("challenge");if(token&&/^[A-Za-z0-9_-]{16,256}$/.test(token)){sessionStorage.setItem("${STORAGE_KEY}",JSON.stringify({token:token,expiresAt:Date.now()+${MAX_AGE_MS}}));}}}catch(e){}})();`;

export function captureWhatsAppLink(): void {
  if (
    typeof window === "undefined" ||
    window.location.pathname !== "/whatsapp/link"
  )
    return;
  const { hash, search } = window.location;
  window.history.replaceState(null, "", "/whatsapp/link");
  if (!hash && !search) return;
  try {
    clearWhatsAppChallenge();
    const token = new URLSearchParams(hash.slice(1)).get("challenge");
    if (token && /^[A-Za-z0-9_-]{16,256}$/.test(token)) {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ token, expiresAt: Date.now() + MAX_AGE_MS })
      );
    }
  } catch {
    /* Storage unavailable: fail closed and offer a fresh link. */
  }
}

export function readWhatsAppChallenge(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const value: unknown = JSON.parse(raw);
    if (
      value &&
      typeof value === "object" &&
      "token" in value &&
      "expiresAt" in value &&
      typeof value.token === "string" &&
      /^[A-Za-z0-9_-]{16,256}$/.test(value.token) &&
      typeof value.expiresAt === "number" &&
      value.expiresAt > Date.now() &&
      value.expiresAt <= Date.now() + MAX_AGE_MS
    )
      return value.token;
    clearWhatsAppChallenge();
  } catch {
    /* Never report private continuation contents. */
  }
  return null;
}

export function clearWhatsAppChallenge(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* Storage may be disabled. */
  }
}
